import Pagination from '@/components/common/Pagination'

export default {
  install (Vue) {
    Vue.component('Pagination', Pagination)
  }
}
